interface ActionTypes {
  GET_ANONYMOUS_ENQUIRY_START: string;
  GET_ANONYMOUS_ENQUIRY_SUCCESS: string;
  GET_ANONYMOUS_ENQUIRY_FAILURE: string;
  GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_START: string;
  GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_SUCCESS: string;
  GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_FAILURE: string;
  GET_ANONYMOUS_CREDENTIAL_START: string;
  GET_ANONYMOUS_CREDENTIAL_SUCCESS: string;
  GET_ANONYMOUS_CREDENTIAL_FAILURE: string;
}

export const AnonymousViewActionTypes: ActionTypes = {
  GET_ANONYMOUS_ENQUIRY_START: '@@GET_ANONYMOUS_ENQUIRY_START',
  GET_ANONYMOUS_ENQUIRY_SUCCESS: '@@GET_ANONYMOUS_ENQUIRY_SUCCESS',
  GET_ANONYMOUS_ENQUIRY_FAILURE: '@@GET_ANONYMOUS_ENQUIRY_FAILURE',
  GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_START:
    '@@GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_START',
  GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_SUCCESS:
    '@@GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_SUCCESS',
  GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_FAILURE:
    '@@GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_FAILURE',
  GET_ANONYMOUS_CREDENTIAL_START: '@@GET_ANONYMOUS_CREDENTIAL_START',
  GET_ANONYMOUS_CREDENTIAL_SUCCESS: '@@GET_ANONYMOUS_CREDENTIAL_SUCCESS',
  GET_ANONYMOUS_CREDENTIAL_FAILURE: '@@GET_ANONYMOUS_CREDENTIAL_FAILURE'
};

export interface AnonymousViewState {
  anonymousEnquiry?: any;
  isLoadingData?: boolean;
  anonymousEnquiryError?: any;
  anonymousEnquiryAutoRenewProperties?: any;
  isLoadingAutoRenewPropertiesData?: boolean;
  credentials?: { token: string; username: string };
  state: 'loading' | 'success' | 'fail';
  error?: string;
}
